import React from "react";
import Head from "next/head";
import { useRouter } from "next/router";
import {
  CONFIRMATION,
  DEAR_DR_PDF,
  DEAR_SDM_PDF,
  ENHANCE_PDF,
  HANDLER,
  PREP_FQ_PDF,
  RECOVER_EMAIL,
  RESET_PASSWORD,
} from "../constants/routes";
import Script from "next/script";

const pagesToExclude = [
  PREP_FQ_PDF,
  ENHANCE_PDF,
  DEAR_SDM_PDF,
  DEAR_DR_PDF,
  CONFIRMATION,
  RESET_PASSWORD,
  HANDLER,
  RECOVER_EMAIL,
];
function GoogleAnalytics() {
  const router = useRouter();
  return (
    <React.Fragment>
      {process.env.NODE_ENV === "production" &&
        process.env.NEXT_PUBLIC_ENABLE_ANALYTICS === "true" &&
        pagesToExclude.every((page) => !router.pathname.includes(page)) && (
          <Script
            key="google-analytics-1"
            id="google-analytics-1"
            strategy="afterInteractive"
            type="text/javascript"
            src={`https://www.googletagmanager.com/gtag/js?id=${process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_TRACKING_ID}`}
          />
        )}
      {process.env.NODE_ENV === "development" &&
        process.env.NEXT_PUBLIC_ENABLE_ANALYTICS === "true" &&
        pagesToExclude.every((page) => !router.pathname.includes(page)) && (
          <Script
            key="google-analytics-2"
            id="google-analytics-2"
            strategy="afterInteractive"
            type="text/javascript"
            dangerouslySetInnerHTML={{
              __html: `window.dataLayer = window.dataLayer || [];
                  function gtag(){dataLayer.push(arguments);}
                  gtag('js', new Date());
                  gtag('config', '${process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_TRACKING_ID}');`,
            }}
          />
        )}
    </React.Fragment>
  );
}

export default GoogleAnalytics;
